/*******************************
for images to use for src URL
*******************************/
// assets search
import assetsNoResults from './assets-no-results.svg';

import * as symbols from './symbols';

// THESE EXPORTS ARE FLAT: be careful with objec names
// names could get conflicted
// these are divided in folders to find easier
// but to avoid `not found`, not changing the structure
export * from './logos';
export * from './bg';
export * from './icons';
export {
  // symbols used for menu icons
  symbols,
  // assets search table
  assetsNoResults
};



// WEBPACK FOOTER //
// ./src/images/index.js